import React from "react";
import { Paper, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { formatItemFragment } from '../../utils/formatItems';

function renderItems(items) {
  if (Array.isArray(items)) {
    return items.map((it, idx) => (
      <React.Fragment key={idx}>
        {formatItemFragment(it.name, it.quantity, it.value_min, it.value_max)}
        {idx < items.length - 1 && " + "}
      </React.Fragment>
    ));
  }
  if (typeof items === "string") return items || "none";
  return "none";
}

const AdminDeleteTradeCard = ({ trade, onRemove }) => {
  return (
    <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 2, position: "relative" }}>
      <IconButton
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
        onClick={onRemove}
      >
        <CloseIcon />
      </IconButton>

      {/* Header: username */}
      <Typography variant="h6" color="secondary">
        {trade.user?.username || "Unknown user"}
      </Typography>

      {/* Subheader: ids */}
      <Typography variant="body2" color="text.secondary">
        trade id: {trade.tradeId} | user id: {trade.user?.id ?? "-"}
        {trade.user?.discord_id ? ` | Discord: ${trade.user.discord_id}` : ""}
      </Typography>

      <Typography variant="body2" sx={{ mt: 1 }}>
        <strong>Date:</strong> {trade.tradeDate || "-"}
      </Typography>

      <Divider sx={{ my: 1 }} />

      <Typography variant="body2">
        <strong>Items Sent:</strong> {renderItems(trade.itemsSent)}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        <strong>Items Received:</strong> {renderItems(trade.itemsReceived)}
      </Typography>

      <Typography variant="body2" sx={{ mt: 1 }}>
        <strong>Notes:</strong> {trade.notes || "none"}
      </Typography>
    </Paper>
  );
};

export default AdminDeleteTradeCard;
